import { CALL_ENDED, NO_ANSWER } from 'utils/constants'
import { Avatar, cn, Paragraph } from '@quickmd-llc/design-system'
import { DailyFooter } from './DailyFooter'
import { useDailyVisit } from '../hooks/useDailyVisit'

export function RemoteVideoOffContent() {
  const { patientWithVisitInfo, is, not, isPhoneCall, isPrepMode } = useDailyVisit()
  return (
    <div
      className={cn('flex h-full w-full flex-col items-center justify-center gap-sp-3 bg-deep-navy-95', {
        'bg-coastal-blue-90': is('CALL_IS_ACTIVE'),
        'bg-red-95': is('PROVIDER_WAS_CONNECTED_BUT_PATIENT_CONNECTION_FAILED'),
      })}>
      <Avatar
        name={`${patientWithVisitInfo.FirstName} ${patientWithVisitInfo.LastName}`}
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        src={patientWithVisitInfo.ImageUrl}
        size='xxl'
        className={cn('absolute flex self-center', not('CALL_IS_ACTIVE') && 'opacity-50')}
      />
      <div className='absolute flex self-center'>
        {isPrepMode ?
          null
        : is('PROVIDER_CONNECTED_AND_WAITING_FOR_PATIENT_CONNECTION', 'PROVIDER_CONNECTING') ?
          <Paragraph className='text-center font-semibold text-white' size='xl'>
            Calling {patientWithVisitInfo.FirstName}
          </Paragraph>
        : is('PROVIDER_WAS_CONNECTED_BUT_PATIENT_CONNECTION_FAILED') ?
          <Paragraph className='text-center font-semibold text-white' size='xl'>
            {isPhoneCall ? CALL_ENDED : NO_ANSWER}
          </Paragraph>
        : is('CONNECTED_CALL_ENDED', 'IDLE') ?
          <Paragraph className='text-center font-semibold text-white' size='xl'>
            {CALL_ENDED}
          </Paragraph>
        : null}
      </div>

      {isPrepMode || is('CONNECTED_CALL_ENDED', 'PROVIDER_WAS_CONNECTED_BUT_PATIENT_CONNECTION_FAILED', 'IDLE') ?
        <div className='absolute bottom-0 z-20 flex w-full'>
          <DailyFooter />
        </div>
      : null}
    </div>
  )
}
